// utils/downloadYaml.js
export function downloadYamlFile(fileName, yamlText) {
  // ①  Make a Blob
  const blob = new Blob([yamlText], { type: 'text/yaml;charset=utf-8' });

  // ②  Create a temporary object URL
  const url = URL.createObjectURL(blob);

  // ③  Fire a hidden <a download> click
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.endsWith('.yaml') ? fileName : `${fileName}.yaml`;
  document.body.appendChild(a);
  a.click();

  // ④  Cleanup
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
